import { z } from 'zod';
export const CoordinatesVO = z.tuple([z.number().min(-90).max(90), z.number().min(-180).max(180)]);
//# sourceMappingURL=coordinates.js.map